import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const content = [
    {
        logo: require('./../../images/client-logo/ihcastings.png'),
    },
    {
        logo: require('./../../images/client-logo/logo.gif'),
    },
    {
        logo: require('./../../images/client-logo/mahadev.png'),
    },
    {
        logo: require('./../../images/client-logo/pritika-group.jpg'),
    },
    {
        logo: require('./../../images/client-logo/varungroup.webp'),
    },
    {
        logo: require('./../../images/client-logo/YIL3D.gif'),
    },
    {
        logo: require('./../../images/client-logo/kaizen.png'),
    },
    {
        logo: require('./../../images/logo/D.K INDUSTRIES.jpg'),
    },
    {
        logo: require('./../../images/logo/Invent Casting.png'),
    },
    {
        logo: require('./../../images/logo/OMBRASS INDUSTRIES PRIVATE LIMITED.png'),
    },
    {
        logo: require('./../../images/logo/RAVI ENTERPRISE.jpg'),
    },
    {
        logo: require('./../../images/logo/S.B ENGINEERS.jpg'),
    },
    {
        logo: require('./../../images/logo/SHAILESH STEEL FORGING.jpg'),
    },
    {
        logo: require('./../../images/logo/SHREE METAL CAST.jpg'),
    },
    {
        logo: require('./../../images/logo/VISHWA CNC TECHNOLOGIES PVT LTD.png'),
    },
    {
        logo: require('./../../images/logo/X-TRIMS INC..jpg'),
    }
]


class ClientSlider1 extends Component {

    render() {

        const settings = {
            dots: false,
            infinite: true,
            speed: 300,
            slidesToShow: 5,
            slidesToScroll: 1,
            autoplay: true,
			responsive: [
				{
				  breakpoint: 1200,
				  settings: {
					slidesToShow: 4
				  }
				},
				{
				  breakpoint: 991,
				  settings: {
					slidesToShow: 3
				  }
				},
				{
				  breakpoint: 576,
				  settings: {
					slidesToShow: 2
				  }
				}
			]
        };

        const Border = this.props.hideBorder ? "" : "border"
        const padding = this.props.allowPadding ? "p-a25":""

        return (
            <>
                <Slider {...settings} className="client-logo-carousel btn-style-1 icon-2">
                    {content.map((item, id) => (
                        <div className="item">
                            <div class={`ow-client-logo ${padding}`}>
                                <div class={`client-logo ${Border}`}>
                                    <Link to="#"><img src={item.logo} alt=""/></Link>
                                </div>
                            </div>
                        </div>
                    ))}
                </Slider>

            </>
        )
    }
}
export default ClientSlider1;